<template>
    <div v-if="!hide"  class="form-network form-network-facebook">
        <details v-if="hasPersonalConciergeriePage" open>
            <summary>{{ $t('dash.post-creator.form.facebook.privacy') }} <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <SelectComponent :valueSelect="formDataNetwork.visibility" :changeValueSelect="changeVisibilityPost" :data="{all:$t('dash.post-creator.form.facebook.visibility-public'), friends:$t('dash.post-creator.form.facebook.visibility-friends'),me:$t('dash.post-creator.form.facebook.visibility-me')}"  :positionAuto="false" :positionX="'left'"></SelectComponent>
            </div>
        </details>
        <details open>
            <summary>{{ $t('dash.post-creator.form.facebook.visibility') }} <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <div class="list-simple-btn">
                    <div class="type-btn-simple" @click="addMode('addPlaceMode')">
                        <i class="fa-solid fa-map-pin"></i>
                        <p>{{ $t('dash.post-creator.form.facebook.place') }} <span class="pink">({{ formData.formDataNetwork.facebook.place ? '1' : '0' }})</span></p>
                
                    </div>    
                </div>         
            </div>      
        </details>
        <details v-if="formData && formData.urlsTextContentHistory && formData.urlsTextContentHistory.length" open>
            <summary>{{ $t('dash.post-creator.form.facebook.link-preview') }} <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <div class="list-thubmmail">
             

                    <div class="thubmmail" v-for="(url) in this.formData.urlsTextContentHistory" @click="()=>selectUrl(url)" :key="url">
                        <Checkbox :id="url" :prefixId="'thubmmail-'" 
                            :isChecked="(formDataNetwork.snippet.link == url)" 
                            :isDisable="(formDataNetwork.snippet.link == url)"
                            :add="selectUrl" :remove="()=>{}">
                        </Checkbox>
                        <SnippetNetwork 
                            :link="url"
                            :imageUrlDefault="formDataNetwork.snippet.imageUrl ? formDataNetwork.snippet.imageUrl : undefined" 
                            :titleDefault="formDataNetwork.snippet.title ? formDataNetwork.snippet.title : undefined" 
                            :descriptionDefault="formDataNetwork.snippet.description ? formDataNetwork.snippet.description : undefined">
                        </SnippetNetwork>
                    </div>
                </div>
                <!-- <div class="type-switch">
                    Apporter des modifications à l'aperçu du lien
                    <ComponentSwitch :value="inputModel.switchCustomSnippet" :onChange="(v)=> inputModel.switchCustomSnippet = v" :id="'switch-settings-advanced-facebook-2'"></ComponentSwitch>
                </div>
            
                <template v-if="inputModel.switchCustomSnippet">
                    <div class="type-btn-add">
                        <i class="fa-solid fa-image" @click="()=> formDataNetwork.snippet.imageUrl = '' "></i>
                        Ajouter une image
                        <i class="fa-solid fa-plus" @click="()=> formDataNetwork.snippet.imageUrl ='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR4Xuh673slO7MDTuB8cYoOSpnbSUc7OyKwrA&s'"></i>
                    </div>
                    <div class="type-input">
                        <i class="fa-solid fa-pen-to-square"></i>
                        <input placeholder="Titre par default" v-model="formDataNetwork.snippet.title">
                        <i class="fa-regular fa-square-minus" v-if="formDataNetwork.snippet.title" @click="()=> formDataNetwork.snippet.title =''"></i>
                    </div>
                    <div class="type-input">
                        <i class="fa-solid fa-pen-to-square"></i>
                        <input placeholder="Description par default" v-model="formDataNetwork.snippet.description">
                        <i class="fa-regular fa-square-minus" v-if="formDataNetwork.snippet.title" @click="()=> formDataNetwork.snippet.description =''"></i>
                    </div>
                </template> -->
            </div>
            
        </details>
        <!-- <details open v-if="formDataNetwork.typeMedia == 'video'">
            <summary>Format <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <div class="list-radio-btn">
                    <div class="type-btn-simple" @click="setIsReel(false)">
                        <i class="fa-regular fa-circle" :class="{'fa-solid fa-circle-dot' : !formDataNetwork.isReel}"></i>
                        <p>Vidéo</p>
                    </div>

                    <div class="type-btn-simple" @click="setIsReel(true)">
                        <i class="fa-regular fa-circle" :class="{'fa-solid fa-circle-dot' : formDataNetwork.isReel}"></i>
                        <p>Réel</p>
                    </div>
                </div>  
            </div>      
        </details> -->
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import store from '@/store/index.js';
    import ComponentSwitch from '@/components/dash/utils/switch.vue'
    import SelectComponent from '@/components/dash/utils/select.vue'
    import SnippetNetwork from './../SnippetNetwork.vue'
    import minxinBot from '@/components/mixins/Bots.vue'
    import minxinPost from '@/components/mixins/Posts.vue'
    import Checkbox from '@/components/dash/utils/checkbox.vue'

    import {formatFileAcceptedByNetwork} from './../../../constante.js'
    export default {

        components: {
            ComponentSwitch,
            SelectComponent,
            SnippetNetwork,
            Checkbox
        },
        mixins: [minxinBot,minxinPost],

        props: {
            hide : {
                type: Boolean,
                default: false
            },
            formData: {
                type: Object,
                default: () => ({})
            },
            formDataNetwork: {
                type: Object,
                default: () => ({})
            },
            files:Object
           
        },
        
        data() {
            return {
                inputModel:{
                    switchCustomSnippet: false,
                    urlImageSnippet: "",
                    titleSnippet: "",
                    descriptionSnippet: "",
                },

                lastModeSelected : undefined
            }
        },

        created () {
      
        },

        mounted() {
            if (this.formData.formDataNetwork.facebook) this.formDataNetwork = this.formData.formDataNetwork.facebook

            EventBus.$on('eventSearchFromSelectPlace', this.searchPlace);
            EventBus.$on('eventClickSelectPlace', this.addPlace);
            EventBus.$on('eventRemoveSelectPlace', this.removePlace);
            console.log("mounted form facebook", this.formData.files) 
            this.$nextTick(() => {
                this.detectTypeMedia()
            })
        },

        methods: {
            addMode(mode) {
                this.lastModeSelected = mode
                EventBus.$emit("postCreatorAddMode", mode);
            },

            changeVisibilityPost(state) {
                this.formDataNetwork.visibility = state
                this.$emit('setFormDataNetwork', 'facebook', this.formDataNetwork)
            },

            selectUrl(url) {
                
                if (!this.formDataNetwork.snippet) this.formDataNetwork.snippet = {}
                this.formDataNetwork.snippet.link = this.formDataNetwork.snippet.link == url ? '' : url
                this.$emit('setFormDataNetwork', 'facebook', this.formDataNetwork)
            },

            verifUrlSelected() {
                if (this.formData.urlsTextContentHistory.length) {
                    let linkSelect = this.formDataNetwork && this.formDataNetwork.snippet && this.formDataNetwork.snippet.link ? this.formDataNetwork.snippet.link : null
                    if ((linkSelect && !this.formData.urlsTextContentHistory.includes(linkSelect))) {
                        this.selectUrl('')
                    }
                }else{
                    this.selectUrl('')
                }
             
            },
            
            detectTypeMedia() {
                console.log("detectTypeMedia facebook", this.formData.files.length)
                if(this.formData.files.length) {
                    try {
                        const types = new Set(
                            this.formData.files
                                .filter(f => this.files[f.id] && ['video','image'].includes(this.files[f.id].info.type2))
                                .map(f => this.files[f.id].info.type2)
                        )
                        if (this.pagesSelectedIncludeConciergerie && types.has('image') && types.has('video')) {
                            this.formDataNetwork.typeMedia = 'mixed'
                        } else {
                            this.formDataNetwork.typeMedia = this.files[this.formData.files.find(f => this.files[f.id] && ['video','image'].includes(this.files[f.id].info.type2)).id].info.type2
                        }
                        this.$emit('setFormDataNetwork', 'facebook', this.formDataNetwork)
                    } catch (error) {
                        this.formDataNetwork.typeMedia = 'image'
                        console.error("impossible de detecter le type media sur formulaire facebook",error)
                    }
                }else{
                    this.formDataNetwork.typeMedia = 'image'
                }
            },

            async searchPlace(network, value,idEvent) {
                console.log("searchPlace facebook")
                if (network !== 'facebook') return
                let page = this.pagesSelected.find(p => p.network == "facebook" && p.bot_status)
                
                let result = []
                if (page) {
                    try {
                        result = (await this.getLocation(page.id, value)).body.locations
                    } catch (error) {
                        console.error("impossible de recuperer les lieux facebook", error)
                    }
                }
                EventBus.$emit("resultSearchFromSelectPlace", result, idEvent)
            },

            addPlace(network, place) {
                if (network !== 'facebook') return
                this.formDataNetwork.place = place
                this.$emit('setFormDataNetwork', 'facebook', this.formDataNetwork)
            },

            removePlace(network) {
                if (network !== 'facebook') return
                this.formDataNetwork.place = undefined
                this.$emit('setFormDataNetwork', 'facebook', this.formDataNetwork)
            },

            setIsReel(isReel) {
                this.formDataNetwork.isReel = isReel
                this.$emit('setFormDataNetwork', 'facebook', this.formDataNetwork)
            },

            fileAdded() {
                this.detectTypeMedia()
                console.log("fileAdded facebook", this.formData.files, JSON.parse(JSON.stringify(this.formData.files)))
                if (this.formData.files.find(f => this.files[f.id] &&  this.files[f.id].info && ['video','image'].includes(this.files[f.id].info.type2))) {
                    this.selectUrl('')
                }
            },

          
        },


       

        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },
            pagesSelectedIncludeConciergerie() {
                return this.pagesSelected.filter(page => page.network == 'facebook' && page.story_config && page.story_config.created).length
            },
            hasPersonalConciergeriePage() {
                return this.pagesSelected.some(page =>
                    page.network == 'facebook'
                    && page.story_config && page.story_config.created
                    && !(page.bots && page.bots[0] && page.bots[0].page && page.bots[0].page.story_config && page.bots[0].page.story_config.i_user)
                    && !page.isGroup
                    && !page.affected_to
                )
            },
        },

        watch: {
            ['formData.formDataNetwork.facebook']() {
                if (this.formData.formDataNetwork.facebook) this.formDataNetwork = this.formData.formDataNetwork.facebook
            },
            'formData.urlsTextContentHistory'(newValue) {
                this.verifUrlSelected()
            },

            'inputModel.switchCustomSnippet' (newValue) {
                if(!newValue) {
                    this.formDataNetwork.snippet.imageUrl = ''
                    this.formDataNetwork.snippet.title = ''
                    this.formDataNetwork.snippet.description = ''
                }
            }
        },


        beforeDestroy () {
            EventBus.$off('eventSearchFromSelectPlace', this.searchPlace);
            EventBus.$off('eventClickSelectPlace', this.addPlace);
            EventBus.$off('eventRemoveSelectPlace', this.removePlace);
        }
        
    }
</script>